/* MGG Filament Colour Library: finish looks, example prints, filters, and the
   product-page library picker (<mgg-library-pick>). Cards are server-rendered by
   sections/mgg-colour-library.liquid; this file only enhances them. */
(function(){
  if (window.MGGLib) return;

  var LABELS = {standard:"Standard",matte:"Matte",silk:"Silk",glitter:"Glitter",galaxy:"Galaxy",glow:"Glow","burnt titanium":"Burnt Titanium",marble:"Marble",shimmer:"Shimmer",sparkle:"Sparkle",wood:"Wood",gradient:"Gradient",coex:"Colour-Shift",translucent:"Translucent",twinkling:"Twinkling",twisted:"Twisted"};
  var SPARKLY = ["glitter","galaxy","shimmer","sparkle","burnt titanium","twinkling"];
  var FINE = ["sparkle","twinkling"];   // fine, randomly scattered flakes (drawn as an SVG layer)
  var CLEAR = ["translucent","twinkling"];

  // small seeded random so each colour always gets the same speck / flake layout
  function rng(seed){ var h = 2166136261; for (var i = 0; i < seed.length; i++){ h ^= seed.charCodeAt(i); h = Math.imul(h, 16777619); }
    return function(){ h += 0x6D2B79F5; var t = h; t = Math.imul(t ^ t >>> 15, t | 1); t ^= t + Math.imul(t ^ t >>> 7, t | 61); return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function dots(seed, n, rMin, rMax, fill, opMin){
    var r = rng(seed), c = "";
    for (var i = 0; i < n; i++) c += '<circle cx="'+(r()*100).toFixed(1)+'" cy="'+(r()*100).toFixed(1)+'" r="'+(rMin + r()*(rMax - rMin)).toFixed(2)+'" fill="'+fill+'" fill-opacity="'+(opMin + r()*(1 - opMin)).toFixed(2)+'"/>';
    return "url('data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">' + c + '</svg>') + "') 0 0/100% 100%"; }
  function specks(it){ return dots("m" + (it.code || it.c.join()), 110, .2, .5, it.sc || "#1b1b1b", .75); }
  function flakes(it){ var c = it.c[0];
    return dots("s" + (it.code || it.c.join()), 150, .18, .55, "#ffffff", .35) + "," + dots("t" + (it.code || it.c.join()), 60, .2, .5, mix(c, .7), .5); }
  var uid = 0;

  function mix(hex, amt){ var n = parseInt(hex.slice(1),16), r=n>>16, g=(n>>8)&255, b=n&255, t=amt<0?0:255, p=Math.abs(amt);
    r=Math.round(r+(t-r)*p); g=Math.round(g+(t-g)*p); b=Math.round(b+(t-b)*p); return "rgb("+r+","+g+","+b+")"; }

  function swatch(it){ var c = it.c[0], extra = "";
    if (FINE.indexOf(it.f) >= 0) extra = flakes(it) + ",";
    if (CLEAR.indexOf(it.f) >= 0) extra += "linear-gradient(115deg,rgba(255,255,255,.55) 0%,rgba(255,255,255,0) 28%,rgba(255,255,255,0) 60%,rgba(255,255,255,.35) 72%,rgba(255,255,255,0) 84%),";
    if (it.p === "gradient") return "background:"+extra+"linear-gradient(180deg,"+it.c.join(",")+")";
    if (it.p === "twisted"){ var st = "", n = it.c.length, w = 7;
      for (var i = 0; i < n; i++) st += it.c[i]+" "+(i*w)+"px "+((i+1)*w - 1)+"px,";
      return "background:"+extra+"repeating-linear-gradient(-8deg,"+st+it.c[0]+" "+(n*w)+"px)"; }
    if (it.p === "coex") return it.c.length === 2
      ? "background:linear-gradient(120deg,"+it.c[0]+" 0%,"+it.c[0]+" 42%,"+it.c[1]+" 58%,"+it.c[1]+" 100%)"
      : "background:linear-gradient(120deg,"+it.c[0]+" 0%,"+it.c[0]+" 28%,"+it.c[1]+" 42%,"+it.c[1]+" 58%,"+(it.c[2]||it.c[1])+" 72%,"+(it.c[2]||it.c[1])+" 100%)";
    if (FINE.indexOf(it.f) >= 0 || CLEAR.indexOf(it.f) >= 0) return "background:"+extra+"linear-gradient(135deg,"+mix(c,.2)+","+c+" 55%,"+mix(c,-.15)+")";
    switch(it.f){
      case "silk": return "background:linear-gradient(100deg,"+mix(c,-.42)+" 0%,"+c+" 26%,"+mix(c,.75)+" 38%,"+mix(c,.75)+" 42%,"+c+" 56%,"+mix(c,-.3)+" 82%,"+mix(c,-.45)+" 100%)";
      case "matte": return "background:linear-gradient(180deg,"+mix(c,.08)+","+c+")";
      case "glow": return "background:radial-gradient(circle at 50% 45%,"+mix(c,.45)+","+c+" 65%);box-shadow:inset 0 0 34px "+mix(c,.6);
      case "shimmer": return "background:linear-gradient(135deg,"+mix(c,-.2)+","+c+" 45%,"+mix(c,.4)+" 60%,"+c+")";
      case "marble": return "background:"+specks(it)+",linear-gradient(160deg,"+mix(c,.06)+","+c+" 60%,"+mix(c,-.05)+")";
      case "burnt titanium": return "background:linear-gradient(140deg,"+mix(c,-.25)+","+c+" 45%,"+mix(c,.25)+" 70%,"+c+")";
      case "wood": return "background:repeating-linear-gradient(100deg,"+c+" 0 7px,"+mix(c,-.18)+" 8px 11px)";
      default: return "background:linear-gradient(100deg,"+mix(c,-.22)+" 0%,"+c+" 30%,"+mix(c,.16)+" 46%,"+c+" 64%,"+mix(c,-.2)+" 100%)";
    } }

  // shine: "gloss" = narrow bright band (silk and friends), "soft" = wide gentle sheen
  function vase(fillDef, fillRef, extra, shine){
    return '<svg viewBox="0 0 120 160" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><defs>'+fillDef+'</defs>'
      + '<use href="#fcl-vase" fill="'+fillRef+'" '+(extra||"")+'/>'
      + (shine ? '<use href="#fcl-vase" fill="url(#fcl-'+shine+')"/>' : "")
      + '<use href="#fcl-vase" fill="url(#fcl-layers)"/></svg>'; }
  function grad(cols, shine){ var id = "fclg"+(++uid);
    var stops = cols.map(function(c,i){ return '<stop offset="'+Math.round(i/(cols.length-1)*100)+'%" stop-color="'+c+'"/>'; }).join("");
    return vase('<linearGradient id="'+id+'" x1="0" y1="0" x2="0" y2="1">'+stops+'</linearGradient>', "url(#"+id+")", "", shine); }
  // coex: bands sliding sideways as if the print turns
  function bands(cols){
    var id = "fclb"+(++uid), n = cols.length, per = 64 * n, stops = "";
    for (var i = 0; i < n; i++){
      var a = i / n, b = (i + 1) / n, blend = .16 / n;
      stops += '<stop offset="'+(a + blend).toFixed(3)+'" stop-color="'+cols[i]+'"/>'
             + '<stop offset="'+(b - blend).toFixed(3)+'" stop-color="'+cols[i]+'"/>';
    }
    stops = '<stop offset="0" stop-color="'+cols[n-1]+'"/>' + stops + '<stop offset="1" stop-color="'+cols[0]+'"/>';
    return vase('<linearGradient id="'+id+'" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="'+per.toFixed(1)+'" y2="0" spreadMethod="repeat">'+stops
      + '<animateTransform attributeName="gradientTransform" type="translate" from="0 0" to="'+per.toFixed(1)+' 0" dur="'+(3*n)+'s" repeatCount="indefinite"/></linearGradient>',
      "url(#"+id+")", "", "gloss"); }
  // twisted: thin slanted stripes of each colour
  function twist(cols){ var id = "fclt"+(++uid), n = cols.length, stops = "";
    for (var i = 0; i < n; i++) stops += '<stop offset="'+(i/n).toFixed(3)+'" stop-color="'+cols[i]+'"/><stop offset="'+((i+1)/n - .02).toFixed(3)+'" stop-color="'+cols[i]+'"/>';
    return vase('<linearGradient id="'+id+'" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="4" y2="'+(4.2*n).toFixed(1)+'" spreadMethod="repeat">'+stops+'</linearGradient>', "url(#"+id+")", "", "gloss"); }
  function example(it){ var inner, dark = it.f === "glow";
    var gloss = SPARKLY.concat(["silk"]).indexOf(it.f) >= 0;
    if (it.p === "coex") inner = bands(it.c);
    else if (it.p === "twisted") inner = twist(it.c);
    else if (it.p === "gradient") inner = grad(it.c, gloss ? "gloss" : "soft");
    else if (it.f === "glow") inner = vase("", mix(it.c[0],.25), 'style="filter:drop-shadow(0 0 14px '+it.c[0]+') drop-shadow(0 0 30px '+it.c[0]+')"');
    else if (it.f === "matte" || it.f === "wood") inner = grad([mix(it.c[0],.12), it.c[0], mix(it.c[0],-.12)]);
    else inner = vase("", it.c[0], CLEAR.indexOf(it.f) >= 0 ? 'fill-opacity=".72"' : "", gloss || CLEAR.indexOf(it.f) >= 0 ? "gloss" : "soft");
    var sp = FINE.indexOf(it.f) >= 0 ? '<div class="fcl-glitter fcl-fine" style="background:'+flakes(it)+'"></div>'
      : (SPARKLY.indexOf(it.f) >= 0 ? '<div class="fcl-glitter" style="opacity:.5"></div>' : "");
    return '<div class="fcl-face fcl-example'+(dark?" fcl-dark":"")+'">'+inner+sp+'<span class="fcl-tag">example print coming soon</span></div>'; }

  function readCard(card){
    return { f: card.getAttribute("data-f"), p: card.getAttribute("data-p") || "solid",
      c: (card.getAttribute("data-c") || "#cccccc").split(","),
      code: card.getAttribute("data-code"), label: card.getAttribute("data-label"),
      sc: card.getAttribute("data-sc") || "", oos: card.getAttribute("data-oos") === "1", ltd: card.getAttribute("data-ltd") === "1" }; }

  function codeKey(s){
    s = String(s || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    return s.replace(/^([A-Z]+)(\d)$/, "$10$2"); }

  function enhance(root, opts){
    if (!root || root.__mgg) return root && root.__mgg;
    opts = opts || {};
    var byCode = {};
    root.querySelectorAll(".fcl-card").forEach(function(card){
      var it = readCard(card);
      card.__it = it;
      if (it.f === "glow") card.style.setProperty("--glow", it.c[Math.floor(it.c.length / 2)]);
      if (it.code) byCode[codeKey(it.code)] = card;
      var sw = card.querySelector(".fcl-swatch");
      if (sw){
        sw.setAttribute("style", swatch(it));
        sw.innerHTML = (["glitter","galaxy","burnt titanium"].indexOf(it.f) >= 0 ? '<div class="fcl-glitter"></div>' : "") + (it.f === "shimmer" ? '<div class="fcl-shimmer"></div>' : "");
      }
      var media = card.querySelector(".fcl-media");
      if (media){ var stamp = media.querySelector(".fcl-stamp, .fcl-ribbon");
        if (stamp) stamp.insertAdjacentHTML("beforebegin", example(it)); else media.insertAdjacentHTML("beforeend", example(it));
        // colour-shift examples are animated SVGs. Left running, ~60 of them kept the page busy (about 25% CPU)
        // even though they're hidden, so they only play while the card is hovered or flipped open (Oct 2026).
        var anim = media.querySelector(".fcl-example svg");
        if (anim && anim.querySelector("animateTransform") && anim.pauseAnimations){
          card.__anim = anim; anim.pauseAnimations();
          card.addEventListener("mouseenter", function(){ anim.unpauseAnimations(); });
          card.addEventListener("mouseleave", function(){ if (!card.classList.contains("fcl-flipped")) anim.pauseAnimations(); });
        } }
      if (opts.onPick){
        card.setAttribute("role", "button"); card.tabIndex = 0;
        card.setAttribute("aria-label", it.oos ? it.label + ", code " + it.code + ", out of stock" : "Choose " + it.label + ", code " + it.code + (it.ltd ? ", limited edition" : ""));
        if (it.oos) card.setAttribute("aria-disabled", "true");
      }
    });
    root.querySelectorAll(".fcl-sec").forEach(function(s){
      var n = s.querySelectorAll(".fcl-card").length, el = s.querySelector(".fcl-count");
      if (el) el.textContent = n + " colour" + (n === 1 ? "" : "s");
    });
    var pillsEl = root.querySelector(".fcl-pills");
    if (pillsEl && !pillsEl.children.length){
      var groups = [];
      root.querySelectorAll(".fcl-sec").forEach(function(s){ var g = s.getAttribute("data-group"); if (groups.indexOf(g) < 0) groups.push(g); });
      pillsEl.innerHTML = ['<button type="button" data-group="all" class="fcl-active">All</button>'].concat(groups.map(function(g){
        return '<button type="button" data-group="'+g+'">'+(LABELS[g] || g.replace(/\b\w/g, function(m){ return m.toUpperCase(); }))+'</button>'; })).join("");
      var tools = root.querySelector(".fcl-tools");
      if (tools) pageExtras(root, tools, pillsEl);
      else pillsEl.addEventListener("click", function(e){
        var b = e.target.closest("button"); if (!b) return;
        pillsEl.querySelectorAll("button").forEach(function(x){ x.classList.toggle("fcl-active", x === b); });
        var g = b.getAttribute("data-group");
        root.querySelectorAll(".fcl-sec").forEach(function(s){ s.style.display = (g === "all" || s.getAttribute("data-group") === g) ? "" : "none"; });
      });
    }
    root.addEventListener("click", function(e){
      var c = e.target.closest(".fcl-card"); if (!c) return;
      if (opts.onPick){ opts.onPick(c.__it, c); return; }
      root.querySelectorAll(".fcl-card.fcl-flipped").forEach(function(x){ if (x !== c){ x.classList.remove("fcl-flipped"); if (x.__anim) x.__anim.pauseAnimations(); } });
      c.classList.toggle("fcl-flipped");
      if (c.__anim){ if (c.classList.contains("fcl-flipped")) c.__anim.unpauseAnimations(); else c.__anim.pauseAnimations(); }
    });
    if (opts.onPick) root.addEventListener("keydown", function(e){
      if (e.key !== "Enter" && e.key !== " ") return;
      var c = e.target.closest && e.target.closest(".fcl-card"); if (!c) return;
      e.preventDefault(); opts.onPick(c.__it, c);
    });
    var api = {
      find: function(code){ var c = byCode[codeKey(code)]; return c ? c.__it : null; },
      mark: function(code){ root.querySelectorAll(".fcl-card").forEach(function(c){ c.classList.toggle("fcl-picked", !!code && c.__it.code === code); }); },
      swatch: swatch
    };
    root.__mgg = api;
    return api;
  }

  // library page only (Oct 2026): search, in-stock filter, finish pills, spool stripe, colour dots on each heading
  function pageExtras(root, tools, pillsEl){
    var cards = [].slice.call(root.querySelectorAll(".fcl-card")), secs = [].slice.call(root.querySelectorAll(".fcl-sec"));
    var q = tools.querySelector(".fcl-search input"), stock = tools.querySelector(".fcl-instock input"), none = root.querySelector(".fcl-nomatch");
    var group = "all";
    cards.forEach(function(c){ var it = c.__it; c.__q = ((it.label || "") + " " + (it.code || "") + " " + (it.code || "").replace(/-/g, "") + " " + (c.closest(".fcl-sec").querySelector("h2").firstChild.textContent || "")).toLowerCase(); });
    secs.forEach(function(s){
      var h = s.querySelector("h2"), cols = [];
      s.querySelectorAll(".fcl-card").forEach(function(c){ var x = c.__it.c[0]; if (cols.length < 6 && cols.indexOf(x) < 0) cols.push(x); });
      if (h && !h.querySelector(".fcl-dots")) h.insertAdjacentHTML("afterbegin", '<span class="fcl-dots" aria-hidden="true">' + cols.map(function(x){ return '<i style="background:' + x + '"></i>'; }).join("") + '</span>');
    });
    var sp = root.querySelector(".fcl-spool");
    if (sp) sp.innerHTML = cards.filter(function(c){ return c.__it.f === "standard" && c.__it.p === "solid"; }).map(function(c){ return '<i style="background:' + c.__it.c[0] + '"></i>'; }).join("");
    var fins = []; cards.forEach(function(c){ if (fins.indexOf(c.__it.f) < 0) fins.push(c.__it.f); });
    var nf = root.querySelector(".fcl-n-fin"); if (nf) nf.textContent = fins.length;
    var nc = root.querySelector(".fcl-n-cols"); if (nc) nc.textContent = cards.length;
    function apply(){
      var t = (q.value || "").trim().toLowerCase(), t2 = t.replace(/[^a-z0-9 ]/g, ""), only = stock.checked, any = false;
      secs.forEach(function(s){
        var gOk = group === "all" || s.getAttribute("data-group") === group, n = 0;
        s.querySelectorAll(".fcl-card").forEach(function(c){
          var ok = gOk && (!only || !c.__it.oos) && (!t || c.__q.indexOf(t) >= 0 || (t2 && c.__q.indexOf(t2) >= 0));
          c.hidden = !ok; if (ok) n++;
        });
        s.hidden = !n; if (n) any = true;
        var el = s.querySelector(".fcl-count"); if (el) el.textContent = n + " colour" + (n === 1 ? "" : "s");
      });
      if (none) none.hidden = any;
    }
    pillsEl.addEventListener("click", function(e){
      var b = e.target.closest("button"); if (!b) return;
      pillsEl.querySelectorAll("button").forEach(function(x){ x.classList.toggle("fcl-active", x === b); });
      group = b.getAttribute("data-group"); apply();
      var box = root.querySelector(".fcl-sections"), top = box.getBoundingClientRect().top + window.pageYOffset - tools.offsetHeight - 10;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: "smooth" });
    });
    q.addEventListener("input", apply);
    stock.addEventListener("change", apply);
  }

  window.MGGLib = { enhance: enhance, swatch: swatch, codeKey: codeKey };

  function autoInit(){ document.querySelectorAll(".fcl[data-mgg-lib]").forEach(function(r){ if (!r.closest("mgg-library-pick")) enhance(r); }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", autoInit); else autoInit();

  /* ---------- product page picker ---------- */
  if (customElements.get("mgg-library-pick")) return;
  customElements.define("mgg-library-pick", class extends HTMLElement {
    connectedCallback(){
      if (this.__ready) return; this.__ready = true;
      var self = this;
      this.label = this.getAttribute("data-label");
      this.form = document.getElementById(this.getAttribute("data-form"));
      this.prop = this.querySelector(".mlp-prop");
      this.dialog = this.querySelector("dialog");
      this.body = this.querySelector(".mlp-body");
      this.codeIn = this.querySelector(".mlp-code");
      this.msg = this.querySelector(".mlp-msg");
      this.chosen = this.querySelector(".mlp-chosen");
      this.picked = null; this.lib = null; this.loading = null;
      this.dmsg = document.createElement("p"); this.dmsg.className = "mlp-dmsg"; this.dmsg.setAttribute("role", "status"); this.dmsg.hidden = true;
      this.querySelector(".mlp-head").after(this.dmsg);
      this.querySelector(".mlp-open").addEventListener("click", function(){ self.open(); });
      this.querySelector(".mlp-change").addEventListener("click", function(){ self.open(); });
      this.querySelector(".mlp-apply").addEventListener("click", function(){ self.applyCode(); });
      this.codeIn.addEventListener("keydown", function(e){ if (e.key === "Enter"){ e.preventDefault(); self.applyCode(); } });
      this.querySelector(".mlp-close").addEventListener("click", function(){ self.dialog.close(); });
      this.dialog.addEventListener("click", function(e){ if (e.target === self.dialog) self.dialog.close(); });
      if (this.form) this.form.addEventListener("submit", function(e){
        if (self.active && !self.picked){
          e.preventDefault(); e.stopImmediatePropagation();
          self.say("Choose a library colour first.", true);
          self.codeIn.focus();
        }
      }, true);
      // Dawn declares PUB_SUB_EVENTS with const, so it is a global binding but not a window property
      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") subscribe(PUB_SUB_EVENTS.variantChange, function(ev){
        var d = ev && ev.data;
        if (!d || String(d.sectionId) !== self.getAttribute("data-section")) return;
        self.sync(d.variant || null);
      });
      var sel = document.querySelector("#variant-selects-" + this.getAttribute("data-section") + " [data-selected-variant]");
      var v = null; try { v = JSON.parse(sel.textContent); } catch(e){}
      this.sync(v);
    }
    get productForm(){ return this.form ? this.form.closest("product-form") : null; }
    sync(variant){
      this.variant = variant;
      this.active = !!variant && (variant.options || []).indexOf(this.label) >= 0;
      this.hidden = !this.active;
      var pf = this.productForm;
      if (pf) pf.classList.toggle("mlp-on", this.active);
      this.prop.disabled = !(this.active && this.picked);
      if (this.active){ this.load(); this.updateButton(); }
    }
    updateButton(){
      var pf = this.productForm;
      if (!pf || !pf.toggleSubmitButton || !this.variant || !this.variant.available) return;
      if (this.picked) pf.toggleSubmitButton(false);
      else pf.toggleSubmitButton(true, "Choose your library colour");
    }
    say(text, err){ this.msg.textContent = text || ""; this.msg.classList.toggle("mlp-err", !!err); }
    load(){
      var self = this;
      if (this.loading) return this.loading;
      var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "?section_id=mgg-colour-library";
      this.loading = fetch(url).then(function(r){ if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); }).then(function(html){
        var doc = new DOMParser().parseFromString(html, "text/html");
        var root = doc.querySelector(".fcl");
        if (!root) throw new Error("library not found");
        root.querySelectorAll("h1").forEach(function(h){ h.remove(); });
        self.body.innerHTML = "";
        self.body.appendChild(document.importNode(root, true));
        self.root = self.body.querySelector(".fcl");
        self.lib = enhance(self.root, { onPick: function(it){ self.pick(it); } });
        if (self.picked) self.lib.mark(self.picked.code);
        return self.lib;
      }).catch(function(e){
        console.error(e); self.loading = null;
        self.body.innerHTML = '<p class="mlp-loading">Sorry, the colour library could not load. Please try again, or <a href="/pages/filament-colour-library" target="_blank">open it in a new tab</a> and type the code here.</p>';
        throw e;
      });
      return this.loading;
    }
    open(){
      this.say(""); this.dmsg.hidden = true;
      if (!this.dialog.open) this.dialog.showModal();
      this.load().catch(function(){});
    }
    pick(it){
      if (it.oos){
        var t = it.label + " (" + it.code + ") is out of stock right now I'm afraid. Please pick another colour.";
        if (this.dialog.open){ this.dmsg.textContent = t; this.dmsg.hidden = false; } else this.say(t, true);
        return;
      }
      this.dmsg.hidden = true;
      this.picked = it;
      this.prop.value = it.code + " " + it.label;
      this.prop.disabled = !this.active;
      this.codeIn.value = it.code;
      this.chosen.hidden = false;
      this.chosen.querySelector(".mlp-dot").setAttribute("style", swatch(it));
      this.chosen.querySelector(".mlp-chosen-text").innerHTML = "";
      var name = document.createTextNode(it.label), small = document.createElement("small");
      small.textContent = it.code;
      this.chosen.querySelector(".mlp-chosen-text").append(name, small);
      this.querySelector(".mlp-open").textContent = "Browse the colour library";
      if (this.lib) this.lib.mark(it.code);
      this.say("");
      if (this.dialog.open) this.dialog.close();
      this.updateButton();
    }
    clearPick(){
      this.picked = null;
      this.prop.value = ""; this.prop.disabled = true;
      this.chosen.hidden = true;
      if (this.lib) this.lib.mark(null);
      this.updateButton();
    }
    applyCode(){
      var self = this, raw = this.codeIn.value.trim();
      if (!raw){ this.say("Type a colour code, for example SILK-14.", true); return; }
      this.say("Checking…");
      this.load().then(function(lib){
        var it = lib.find(raw);
        if (it && it.oos){ self.clearPick(); self.pick(it); }
        else if (it) self.pick(it);
        else { self.clearPick(); self.say("We can't find “" + raw + "”. Check it against the colour library.", true); }
      }).catch(function(){ self.say("Couldn't check the code just now. Please try again.", true); });
    }
  });

  /* ---------- product page: one library colour per part ("Custom Full Colour", Oct 2026) ----------
     Parts + Full Colour defaults come from the product's custom.colour_parts metafield (rendered into the snippet).
     Saves one line item property per part. Talks to the 3D preview: window.__f3dCustom + "mgg:custom-colours" out,
     "mgg:f3d-use" (the viewer's "Use these colours" button) in. */
  if (customElements.get("mgg-parts-pick")) return;
  customElements.define("mgg-parts-pick", class extends HTMLElement {
    connectedCallback(){
      if (this.__ready) return; this.__ready = true;
      var self = this;
      this.label = this.getAttribute("data-label");
      this.formId = this.getAttribute("data-form");
      this.form = document.getElementById(this.formId);
      try { this.parts = JSON.parse(this.querySelector("[data-parts]").textContent) || []; } catch(e){ this.parts = []; }
      this.defaults = this.parts.map(function(p){ return { code: p.code, label: p.name, c: [p.hex || "#cccccc"], f: p.f || "standard", p: "solid" }; });
      this.cur = this.defaults.slice();
      this.rowsEl = this.querySelector(".mpp-rows");
      this.propsEl = this.querySelector(".mpp-props");
      this.msg = this.querySelector(".mlp-msg");
      this.dialog = this.querySelector("dialog");
      this.body = this.querySelector(".mlp-body");
      this.editing = -1; this.lib = null; this.loading = null;
      this.dmsg = document.createElement("p"); this.dmsg.className = "mlp-dmsg"; this.dmsg.setAttribute("role", "status"); this.dmsg.hidden = true;
      this.querySelector(".mlp-head").after(this.dmsg);
      // one hidden property input per part, owned by the product form
      this.inputs = this.parts.map(function(p){
        var i = document.createElement("input"); i.type = "hidden"; i.name = "properties[" + p.part + "]";
        i.setAttribute("form", self.formId); i.disabled = true; self.propsEl.appendChild(i); return i; });
      this.render();
      this.rowsEl.addEventListener("click", function(e){ var b = e.target.closest("[data-i]"); if (b) self.open(+b.getAttribute("data-i")); });
      this.querySelector(".mpp-reset").addEventListener("click", function(){ self.cur = self.defaults.slice(); self.refreshFromLib(); self.changed(); });
      var b3 = this.querySelector(".mpp-3d");
      if (b3) b3.addEventListener("click", function(){ var o = document.querySelector("[data-m3d-open]"); if (o) o.click(); });
      this.querySelector(".mlp-close").addEventListener("click", function(){ self.dialog.close(); });
      this.dialog.addEventListener("click", function(e){ if (e.target === self.dialog) self.dialog.close(); });
      if (this.form) this.form.addEventListener("submit", function(e){
        if (!self.active) return;
        var bad = self.cur.filter(function(it){ return it.oos; });
        if (bad.length){ e.preventDefault(); e.stopImmediatePropagation();
          self.say(bad.map(function(it){ return it.label; }).join(", ") + " is out of stock right now I'm afraid. Please change it first.", true); }
      }, true);
      // the 3D preview's "Use these colours" button
      window.addEventListener("mgg:f3d-use", function(e){ self.useFromViewer(e.detail || {}); });
      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") subscribe(PUB_SUB_EVENTS.variantChange, function(ev){
        var d = ev && ev.data;
        if (!d || String(d.sectionId) !== self.getAttribute("data-section")) return;
        self.sync(d.variant || null);
      });
      var sel = document.querySelector("#variant-selects-" + this.getAttribute("data-section") + " [data-selected-variant]");
      var v = null; try { v = JSON.parse(sel.textContent); } catch(e){}
      this.sync(v);
      this.publish();
    }
    sync(variant){
      this.variant = variant;
      this.active = !!variant && (variant.options || []).indexOf(this.label) >= 0;
      this.hidden = !this.active;
      this.inputs.forEach(function(i){ i.disabled = !this.active; }, this);
      // hide the express checkout buttons while custom colours are chosen (same as the single library picker)
      var pf = this.form ? this.form.closest("product-form") : null;
      if (pf) pf.classList.toggle("mpp-on", this.active);
      if (this.active){ this.load().then(function(){}, function(){}); this.publish(); }
    }
    say(text, err){ this.msg.textContent = text || ""; this.msg.classList.toggle("mlp-err", !!err); }
    render(){
      var self = this, h = "";
      this.parts.forEach(function(p, i){
        var it = self.cur[i];
        h += '<div class="mpp-row"><span class="mlp-dot" style="' + swatch(it) + '"></span><span class="mpp-txt"><b></b><span></span> <code></code>' +
          (it.oos ? '<em class="mpp-oos">Out of stock</em>' : "") + '</span><button type="button" class="mpp-chg" data-i="' + i + '">Change</button></div>';
      });
      this.rowsEl.innerHTML = h;
      this.rowsEl.querySelectorAll(".mpp-row").forEach(function(r, i){
        r.querySelector("b").textContent = self.parts[i].part;
        r.querySelector(".mpp-txt > span").textContent = self.cur[i].label;
        r.querySelector("code").textContent = self.cur[i].code;
        r.querySelector(".mpp-chg").setAttribute("aria-label", "Change the " + self.parts[i].part + " colour");
      });
      this.inputs.forEach(function(inp, i){ inp.value = self.cur[i].code + " " + self.cur[i].label; });
    }
    map(){ var m = {}, self = this; this.parts.forEach(function(p, i){ m[p.part] = self.cur[i].code; }); return m; }
    publish(){ window.__f3dCustom = this.map(); window.dispatchEvent(new CustomEvent("mgg:custom-colours", { detail: this.map() })); }
    changed(){ this.render(); this.publish(); this.say(""); }
    // swap the metafield's defaults for the library's own entries (proper finish look + stock flags)
    refreshFromLib(){ var lib = this.lib; if (!lib) return;
      this.cur = this.cur.map(function(it){ return lib.find(it.code) || it; }); this.render(); }
    load(){
      var self = this;
      if (this.loading) return this.loading;
      var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "?section_id=mgg-colour-library";
      this.loading = fetch(url).then(function(r){ if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); }).then(function(html){
        var doc = new DOMParser().parseFromString(html, "text/html");
        var root = doc.querySelector(".fcl");
        if (!root) throw new Error("library not found");
        root.querySelectorAll("h1").forEach(function(h){ h.remove(); });
        self.body.innerHTML = "";
        self.body.appendChild(document.importNode(root, true));
        self.lib = enhance(self.body.querySelector(".fcl"), { onPick: function(it){ self.pick(it); } });
        self.refreshFromLib();
        return self.lib;
      }).catch(function(e){
        console.error(e); self.loading = null;
        self.body.innerHTML = '<p class="mlp-loading">Sorry, the colour library could not load. Please try again, or message me with the colours you want.</p>';
        throw e;
      });
      return this.loading;
    }
    open(i){
      this.editing = i; this.dmsg.hidden = true;
      this.querySelector(".mpp-for").textContent = this.parts[i].part.toLowerCase();
      if (!this.dialog.open) this.dialog.showModal();
      var self = this;
      this.load().then(function(lib){ lib.mark(self.cur[i].code); }, function(){});
    }
    pick(it){
      if (it.oos){ this.dmsg.textContent = it.label + " (" + it.code + ") is out of stock right now I'm afraid. Please pick another colour."; this.dmsg.hidden = false; return; }
      if (this.editing < 0) return;
      this.cur[this.editing] = it;
      this.dialog.close();
      this.changed();
    }
    useFromViewer(m){
      var self = this;
      this.load().then(function(lib){
        self.parts.forEach(function(p, i){ var it = m[p.part] && lib.find(m[p.part]); if (it) self.cur[i] = it; });
        self.changed();
        if (!self.active) self.selectOption();
        var bad = self.cur.filter(function(it){ return it.oos; });
        if (bad.length) self.say(bad.map(function(it){ return it.label; }).join(", ") + " is out of stock right now I'm afraid. Please change it first.", true);
      }, function(){});
    }
    // switch the Colour option to this picker's value (radio swatches/pills or a dropdown)
    selectOption(){
      var vs = document.getElementById("variant-selects-" + this.getAttribute("data-section")); if (!vs) return;
      var lab = this.label;
      var r = [].slice.call(vs.querySelectorAll("input[type=radio]")).filter(function(x){ return x.value === lab; })[0];
      if (r){ r.click(); return; }
      [].slice.call(vs.querySelectorAll("select")).forEach(function(s){
        var o = [].slice.call(s.options).filter(function(x){ return x.value === lab; })[0];
        if (o){ s.value = lab; s.dispatchEvent(new Event("change", { bubbles: true })); } });
    }
  });
})();
